"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MLPropertyPageTabs = void 0;

var _enum = _interopRequireDefault(require("enum"));

var MLPropertyPageTabs = new _enum.default({
  "MEDIA": "media",
  "INFORMATION": "info"
});
exports.MLPropertyPageTabs = MLPropertyPageTabs;